export enum TimeSlotSuggestionType {
  Original = 1,
  Fake = 2,
  LimitedDurationAppointment = 3,
  ExtendedTime = 4,
  ExtendedTimeUntilNextAppointment = 5,
}
